import { render } from "./ClubCaptains.vue?vue&type=template&id=63dc9118&ts=true"
import script from "./ClubCaptains.vue?vue&type=script&lang=ts"
export * from "./ClubCaptains.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__